import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import AdminLayout from '@/layouts/AdminLayout.vue'
import ClienteLayout from '@/layouts/ClienteLayout.vue'
import IsleroLayout from '@/layouts/IsleroLayout.vue'
import SubclienteLayout from '@/layouts/SubclienteLayout.vue'
import { Constantes } from '@/util/Constantes'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/404/index.vue')
  },
  {
    path: '/429',
    name: '429',
    component: () => import('@/views/429/index.vue')
  },
  {
    path: '/',
    name: 'Inicio',
    component: () => import('@/views/Usuario/UsuarioInicioSesion.vue')
  },
  {
    path: '/recuperar-password',
    name: 'RecuperarPassword',
    component: () => import('@/views/Usuario/RecuperarPassword.vue')
  },
  {
    path: '/registro-cliente',
    name: 'RegistroCliente',
    component: () => import('@/views/Usuario/RegistroCliente.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/Usuario/ResetPassword.vue')
  },
  {
    path: '/app/admin',
    component: AdminLayout,
    meta: { requiereAutorizacion: true, roles: [Constantes.ROL_ADMIN] },
    children: [
      {
        path: 'menu-admin',
        name: 'MenuAdmin',
        component: () => import('@/views/Menu/MenuAdmin.vue'),
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/Log/index.vue'),
      },
      {
        path: 'productos',
        name: 'Productos',
        component: () => import('@/views/Producto/Producto.vue'),
        props: true,
      },
      {
        path: 'clientes',
        name: 'Clientes',
        component: () => import('@/views/Cliente/Cliente.vue'),
      },
      {
        path: 'isleros',
        name: 'Isleros',
        component: () => import('@/views/Islero/Islero.vue'),
      },
      {
        path: 'admins',
        name: 'Admins',
        component: () => import('@/views/Admin/Admin.vue'),
      },
      {
        path: 'perfil-admin',
        name: 'PerfilAdmin',
        component: () => import('@/views/Admin/Perfil.vue'),
      },
      {
        path: 'autorizaciones-admin',
        name: 'AutorizacionesAdmin',
        component: () => import('@/views/Admin/AutorizacionAdmin.vue'),
      },
      {
        path: 'servicios-admin',
        name: 'ServiciosAdmin',
        component: () => import('@/views/Admin/ServicioAdmin.vue'),
      },
      {
        path: 'recogidas-efectivo-admin',
        name: 'RecogidasEfectivoAdmin',
        component: () => import('@/views/Admin/RecogidaEfectivo.vue'),
      },
      {
        path: 'ubicaciones-eds-admin',
        name: 'UbicacionesEDS',
        component: () => import('@/views/UbicacionEDS/UbicacionEDS.vue'),
      },
      {
        path: 'eds-admin',
        name: 'EDS',
        component: () => import('@/views/EDS/EDS.vue'),
      },
      {
        path: 'anticipos-admin',
        name: 'AnticiposClientesAdmin',
        component: () => import('@/views/Admin/AnticipoClienteAdmin.vue'),
      },
      {
        path: 'anticipos-disponibles',
        name: 'AnticiposClientesDisponibles',
        component: () => import('@/views/Admin/AnticipoClienteDisponible.vue'),
      },
      {
        path: 'cierres-turnos',
        name: 'CierresTurnosAdmin',
        component: () => import('@/views/Admin/CierreTurnoIslero.vue'),
      },
      {
        path: 'surtidores',
        name: 'Surtidores',
        component: () => import('@/views/Surtidor/Surtidor.vue'),
        props: true,
      },
      {
        path: 'mangueras',
        name: 'Mangueras',
        component: () => import('@/views/Manguera/Manguera.vue'),
        props: true,
      },
      {
        path: 'cierre-turno-islero-detalles',
        name: 'CierreTurnoIsleroDetalles',
        component: () => import('@/views/Admin/CierreTurnoIsleroDetalles.vue'),
        props: true
      },
      {
        path: 'lecturas-mangueras-sin-cierre',
        name: 'LecturasManguerasSinCierre',
        component: () => import('@/views/Admin/LecturasManguerasSinCierre.vue'),
      },
    ]
  },
  {
    path: '/app/cliente',
    meta: { requiereAutorizacion: true, roles: [Constantes.ROL_CLIENTE] },
    component: ClienteLayout,
    children: [
      {
        path: 'menu-cliente',
        name: 'MenuCliente',
        component: () => import('@/views/Menu/MenuCliente.vue'),
      },
      {
        path: 'perfil-cliente',
        name: 'PerfilCliente',
        component: () => import('@/views/Cliente/Perfil.vue'),
      },
      {
        path: 'vehiculos-cliente',
        name: 'Vehiculos-cliente',
        component: () => import('@/views/Cliente/Vehiculos.vue'),
      },
      {
        path: 'autorizaciones-cliente',
        name: 'AutorizacionesCliente',
        component: () => import('@/views/Cliente/AutorizacionCliente.vue'),
      },
      {
        path: 'servicios-cliente',
        name: 'ServiciosCliente',
        component: () => import('@/views/Cliente/ServicioCliente.vue'),
      },
      {
        path: 'subcliente',
        name: 'Subcliente',
        component: () => import('@/views/Cliente/Subcliente.vue'),
      },
      {
        path: 'anticipos-cliente',
        name: 'AnticiposCliente',
        component: () => import('@/views/Cliente/AnticipoCliente.vue'),
      },
    ]
  },
  {
    path: '/app/islero',
    meta: { requiereAutorizacion: true, roles: [Constantes.ROL_ISLERO] },
    component: IsleroLayout,
    children: [
      {
        path: 'menu-islero',
        name: 'MenuIslero',
        component: () => import('@/views/Menu/MenuIslero.vue'),
      },
      {
        path: 'autorizaciones-islero',
        name: 'AutorizacionesIslero',
        component: () => import('@/views/Islero/AutorizacionIslero.vue'),
      },
      {
        path: 'servicios-islero',
        name: 'ServiciosIslero',
        component: () => import('@/views/Islero/ServicioIslero.vue'),
      },
      {
        path: 'imprimir',
        name: 'ImprimirTicket',
        component: () => import('@/views/Imprimir/Ticket.vue'),
      },
      {
        path: 'recogidas-efectivo-islero',
        name: 'RecogidasEfectivoIslero',
        component: () => import('@/views/Islero/RecogidaEfectivoIslero.vue'),
      },
      {
        path: 'cierres-turnos-islero',
        name: 'CierresTurnosIslero',
        component: () => import('@/views/Islero/CierreTurno.vue'),
      },
      {
        path: 'cerrar-turno-islero',
        name: 'CerrarTurnoIslero',
        component: () => import('@/views/Islero/CerrarTurno.vue'),
        props: true
      }
    ]
  },
  {
    path: '/app/subcliente',
    meta: { requiereAutorizacion: true, roles: [Constantes.ROL_SUBCLIENTE] },
    component: SubclienteLayout,
    children: [
      {
        path: 'menu-subcliente',
        name: 'MenuSubcliente',
        component: () => import('@/views/Menu/MenuSubcliente.vue'),
      },
      {
        path: 'autorizaciones-subcliente',
        name: 'AutorizacionesSubcliente',
        component: () => import('@/views/Subcliente/AutorizacionSubcliente.vue'),
      },
      {
        path: 'servicios-subcliente',
        name: 'ServiciosSubcliente',
        component: () => import('@/views/Subcliente/ServicioSubcliente.vue'),
      },
      {
        path: 'vehiculos-subcliente',
        name: 'Vehiculos-subcliente',
        component: () => import('@/views/Subcliente/VehiculosSubcliente.vue'),
      },
      {
        path: 'anticipos-subcliente',
        name: 'AnticiposSubcliente',
        component: () => import('@/views/Subcliente/AnticipoSubcliente.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si hay una posición guardada (por ejemplo, al usar "atrás"), restaura esa posición.
    if (savedPosition) {
      return savedPosition;
    } else {
      // Si no, vuelve al inicio de la página.
      return { top: 0 };
    }
  },
})

router.beforeEach((to, from, next) => {
  const rutaProtegida = to.matched.some(record => record.meta.requiereAutorizacion)
  const usuario = store.state.usuario

  if (rutaProtegida && !usuario) {
    // No logueado → redirigir al inicio
    return next({ name: 'Inicio' })
  }

  if (to.meta.roles && usuario) {
    // Validar si el rol del usuario está permitido
    if (!to.meta.roles.includes(usuario.rol_codigo)) {
      return next({ name: 'Inicio' })
    }
  }

  next()
})

export default router
